module.exports = __webpack_public_path__ + "static/media/A4_Size_final_SITS.b58a1238.jpg";